$('.deletedoc-btn').on('click', function () {
    var deleteabsencemodal = $('#deleteabsencemodal');
    var id = $(this).data('id');
    var studentname = $(this).data('studentname');
    var date = $(this).data('date');

    $(deleteabsencemodal).find('#student-name').text(studentname);
    $(deleteabsencemodal).find('input[type="hidden"][name="id"]').val(id);
    $(deleteabsencemodal).find('#absence-dates').text(date);
    $(deleteabsencemodal).modal('show');
});

$('#absenceQuickSearchForm').validate({
    rules: {
        absenceSearchStudentID: {
            required: true,
        },
    },
    messages: {
        absenceSearchStudentID: {
            required: 'Please select a student',
        },
    },
});
